import { render, staticRenderFns } from "./call-panel.vue?vue&type=template&id=5065e322&scoped=true&"
import script from "./call-panel.vue?vue&type=script&lang=js&"
export * from "./call-panel.vue?vue&type=script&lang=js&"
import style0 from "./call-panel.vue?vue&type=style&index=0&id=5065e322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065e322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5065e322')) {
      api.createRecord('5065e322', component.options)
    } else {
      api.reload('5065e322', component.options)
    }
    module.hot.accept("./call-panel.vue?vue&type=template&id=5065e322&scoped=true&", function () {
      api.rerender('5065e322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/call-panel.vue"
export default component.exports